import { Box, Text, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import styles from './AskKluePageBanner.module.css';

type AskKluePageBannerProps = {
  isPage?: boolean;
};

export const AskKluePageBanner = ({
  isPage = false,
}: AskKluePageBannerProps) => {
  const { t } = useTranslation('Dashboard');

  if (!isPage) {
    return null;
  }

  return (
    <Box className={styles.banner}>
      <Stack gap={16} align="center">
        <Text
          // eslint-disable-next-line @kluein/nectar/component-prop-constraints
          size="32px"
          fw={700}
          style={{
            color: '#000',
            marginBottom: '8px',
          }}
        >
          {t('Dashboard:askKlue.pageBanner.title')}
        </Text>
      </Stack>
    </Box>
  );
};
